'use client';
import { createBrowserClient } from '@supabase/ssr';

import { APPLICANT_SITE_URL } from '../constants';
import { extractDomain } from '../url';

const lelandUrl = APPLICANT_SITE_URL;
const hostname = process.env.NEXT_PUBLIC_LELAND_HOST_NAME;
let domain: string | undefined;

if (hostname) {
  domain = hostname;
} else if (lelandUrl) {
  domain = extractDomain(lelandUrl);
}

export function createClient() {
  return createBrowserClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL ?? '',
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY ?? '',
    {
      cookieOptions: {
        domain: `.${domain}`,
        path: '/',
        secure: process.env.NODE_ENV === 'production',
        sameSite: 'lax',
      },
    },
  );
}
